var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27326_1529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.71135 2.10716C9.71099 1.77856 10.11 1.61717 10.3412 1.85521L12.5453 4.12572C12.6892 4.27385 12.6856 4.50332 12.5375 4.6472L10.267 6.85228C10.0288 7.08313 9.63528 6.90989 9.64006 6.58665L9.66349 4.99095C9.0257 4.95232 8.38261 5.01621 7.76115 5.18138C6.08891 5.63866 4.68581 6.83214 3.95646 8.39036C3.14787 10.1513 3.25077 12.2334 4.27287 13.9148C4.29972 13.96 4.31946 14.0083 4.33635 14.0564C5.43119 15.7673 7.38828 16.8846 9.62248 16.7742C11.7903 16.6669 13.7101 15.279 14.6498 13.3181C15.1687 12.2254 15.2869 11.1821 15.1664 10.1951C15.1322 9.9574 15.2164 9.7099 15.393 9.54759C15.8383 9.14566 16.5585 9.40511 16.6293 9.99876C16.7572 10.9861 16.683 12.0315 16.3422 13.1023C15.4552 15.9071 12.9162 17.9773 9.98185 18.2292C5.00954 18.6604 1.04866 14.2248 2.10002 9.28587C2.35953 8.07053 2.92933 6.96564 3.71818 6.0554C3.86254 5.88754 4.01527 5.72431 4.17717 5.56712C5.70658 4.08226 7.71478 3.40746 9.68498 3.5095L9.71135 2.10716ZM16.686 3.74583C17.0013 3.43054 17.5103 3.43055 17.8256 3.74583C18.149 4.06113 18.1487 4.57018 17.8334 4.88548L9.74943 12.9704C9.43413 13.2857 8.92411 13.2857 8.60881 12.9704L6.3217 10.6824C6.0064 10.3671 6.0064 9.85801 6.3217 9.54271C6.637 9.22742 7.14605 9.22741 7.46135 9.54271L9.17521 11.2566L16.686 3.74583Z",
    fill: "#A16C07"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27326_1529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedOrangeIcon);
export default __webpack_public_path__ + "static/media/checked-orange-icon.b3a8e713.svg";
export { ForwardRef as ReactComponent };